import script from "./export-dropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./export-dropdown.vue?vue&type=script&lang=ts&setup=true"

import "./export-dropdown.vue?vue&type=style&index=0&id=4bc88261&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bc88261"]])

export default __exports__